import { Component, Host, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'header-component',
  styleUrl: 'header-component.css',
  scoped: true
})
export class HeaderComponent {


  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";
  /**
    *Required - if header attribute is true
    */
  @Prop() seeall: boolean;

  @Prop() seeallurl: string;

  @Prop() seealltitle: string  ="";

  @Prop() headerbgcolor: string = "white"

  @Prop() headertextcolor: string = "black"
  @Prop() headerborderbottom: string = "1px solid #CE2127"
  // @Prop() titleiconbgcolor: string = "white"
  render() {
   
    let seeAllTitle = "See All"
    if (this.seealltitle)
    {
      seeAllTitle= this.seealltitle
    }

    return (
      this.seeall ?
        <div >
          <div class="row gx-0 section-bg" style={{ backgroundColor: this.headerbgcolor, color: this.headertextcolor,borderBottom: this.headerborderbottom }} >
            {this.titleiconurl != "" ?
              <div>
                <img class=" icon-image img-fluid, float-start" src={this.titleiconurl} alt=" icon" style={{borderTopLeftRadius:"5px"}}  />
                <div style={{ paddingTop: "10px" }} >
                  <span class="section-title">{this.sectiontitle}</span>
                  <a class="see-all-red float-end" style={{ paddingRight: "10px" }} href={this.seeallurl} rel="noopener noreferrer" >
                    <span style={{ paddingRight: "10px" }}>{seeAllTitle}</span>
                  </a>
                </div>
              </div>
              :
              <div style={{ paddingTop: "10px",paddingLeft: "15px" }} >
                <span class="section-title">{this.sectiontitle}</span>
                <a class="see-all-red float-end" style={{ paddingRight: "10px" }} href={this.seeallurl} rel="noopener noreferrer" >
                  <span style={{ paddingRight: "10px" }}>{seeAllTitle}</span>
                </a>
              </div>
            }
          </div>
        </div> :
        <div >
          <div class="row gx-0 section-bg" style={{ backgroundColor: this.headerbgcolor, color: this.headertextcolor,borderBottom: this.headerborderbottom }} >
            <div >
              {this.titleiconurl != "" ?
                <div>
                  <img class=" icon-image img-fluid, float-start" src={this.titleiconurl} alt=" icon" style={{borderTopLeftRadius:"5px"}} />
                  <div style={{ paddingTop: "10px" }} >
                    <span class="section-title">{this.sectiontitle}</span>
                  </div>
                </div>
                :
                <div style={{ paddingTop: "10px", paddingLeft: "15px" }} >
                  <span class="section-title">{this.sectiontitle}</span>
                </div>
              }
            </div>
          </div>
        </div>

    );

  }

}
